export default "__VITE_ASSET__1EPgd5uD__"